module.exports = __webpack_public_path__ + "static/media/brand-name.9a660e09.svg";